import styled from "styled-components";

const UsersStyle = styled.div`
  .user-title-container {
    text-align: left;
    display: flex;
    justify-content: space-between;
  }
  .edit_title_section {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .user-menu-title {
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    color: #1f243b;
  }
  .create-course-button {
    width: 170px;
    height: 34px;
    padding: 6.5px 20px 6.5px 21px;
    border-radius: 8px;
    border: 0.5px;
    background-color: #c2fae5;
    color: #1f243b;
    margin-top: 20px;
  }
  // .users-menu-filter-container {
  //   display: flex;
  //   justify-content: space-between;
  // }
  // .search-input-field {
  //   margin-bottom: 0px !important;
  //   input {
  //     margin-bottom: 0px;
  //   }
  // }
  .course-header-style {
    display: flex;
    justify-content: space-between;
  }
  .course-input-field {
    display: flex;
  }

  .add_form_container_box {
    width: 50%;
  }
  .adduser-container {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 30px;
  }
  .upload-img-box .ant-upload.ant-upload-select {
    width: 180px;
  }
  .form_input_fields {
    font-size: 0.889rem;
    font-weight: 700;
    color: rgb(35, 35, 35);
    .ant-row {
      display: flex;
      flex-direction: column;
    }
  }

  .ant-form-item-label {
    text-align: left;
    font-size: 0.889rem !important;
    font-weight: 700;
    color: rgb(35, 35, 35);
  }

  .form_devided_labels {
    text-align: left;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.3;
    margin: 0px;
    word-break: break-word;
    hyphens: auto;
    margin-bottom: 20px;
  }

  .checkbox_form {
    display: flex;
    justify-content: left;
    text-align: justify;
    margin-bottom: 10px;
  }
  .form_button_section {
    display: flex;
    justify-content: left;
    gap: 10px;
    margin-top: 10px;
  }
  .add-user-button {
    height: 2.5rem;
    min-width: 2.5rem;
    color: rgb(255, 255, 255);
    background-color: rgb(27, 104, 179);
    border: 1px solid rgb(27, 104, 179);

    &:hover {
      background-color: rgb(27, 104, 179) !important;
      border: 1px solid rgb(27, 104, 179) !important;
      color: rgb(255, 255, 255) !important;
    }
  }

  .course-enroll-button {
    color: rgb(27, 104, 179);
    border: none;
    background: none;
    box-shadow: none;
    &:hover {
      color: rgb(27, 104, 179);
      border: none;
      background: none;
      box-shadow: none;
    }
  }

  // .course_filter_section_with_icon {
  //   display: flex;
  //   align-items: center;
  //   gap: 18px;
  // }

  .download_csv_con {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 22px;
    width: 30px;
    height: 30px;
    background-color: rgb(245, 245, 246);
    cursor: pointer;
  }

  .yet-designed-pages {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .developement-content {
    font-size: 1.266rem;
    line-height: 1;
    color: rgb(0, 0, 0);
    margin-bottom: 1rem;
  }
  .developement-span-content {
    font-size: 1.125rem;
    font-weight: 400;
    color: rgb(158, 165, 169);
    margin-bottom: 1rem;
  }
  .developement-add-button {
    font-size: 0.889rem;
    height: 2.5rem;
    min-width: 2.5rem;
    color: rgb(255, 255, 255);
    background-color: rgb(27, 104, 179);
    border: 1px solid rgb(27, 104, 179);
  }
`;

export default UsersStyle;
